export const CLEAR_BUTTON_ICON = 'mapleLeaf';
